export const agdExamsUnauthenticatedProps = {
  basename: "/preparo",
};
